// extracted by mini-css-extract-plugin
export default {"selectContainer":"axnui-select-input__select-container__bUnZB"};